import { createStore, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import combineReducers from "../reducers";

export const store = createStore(
  combineReducers,
  composeWithDevTools(applyMiddleware(ReduxThunk))
);
